<template>
  <b-modal
    id="coupon-submit-success-modal"
    hide-header
    centered
    body-class="custom-modal-body"
    content-class="custom-modal-content"
    footer-class="custom-modal-footer"
  >
    <div>
      <div class="text-center mt-2 mb-3">
        <CustomLottie :animationData="animationData"></CustomLottie>
      </div>
      <h3 class="text-center mb-2">您已成功提交優惠</h3>
      <p class="text-center">
        優惠券需由 U Lifestyle 批核後才會被顯示於 U Lifestyle 平台，批核需時2-5個工作天
      </p>
    </div>
    <template #modal-footer>
      <router-link
        tag="button"
        class="btn btn-secondary"
        :to="`/${$route.path.split('/')[1]}`"
      >
        回到首頁
      </router-link>
      <b-button variant="primary" @click="onAddCoupon">
        建立新優惠
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue';
import CustomLottie from '@/components/CustomLottie.vue';
import animationData from '@/assets/lottie/coupon-submit-success.json';

export default {
  components: {
    BModal,
    BButton,
    CustomLottie,
  },
  data: () => ({
    animationData,
  }),
  methods: {
    onAddCoupon() {
      this.$bvModal.hide('coupon-submit-success-modal');
      // redirect user only when it is edit page to avoid redundant navigation error
      if (this.$route.name.toLowerCase().includes('edit')) {
        this.$router.push(`/${this.$route.path.split('/')[1]}/add`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  color: #636d77;
}

h3 {
  font-size: 1.75rem;
}

p {
  font-size: 0.8rem;
}

::v-deep {
  .custom-modal {
    &-body {
      padding: 32px 32px 28px 32px;

      .mb-3 {
        margin: 0 !important;
      }

      img {
        width: 180px;
      }

      h3 {
        font-size: 18px;
        margin-top: 24px;
        margin-bottom: 12px !important;
        color: #3a4047;
      }

      p {
        font-size: 15px;
        margin-bottom: 0;
      }
    }

    &-content {
      border: none;
    }

    &-footer {
      border: none;
      justify-content: center;
      padding: 0 0 32px 0;

      .btn {
        padding: 10px 18px;
        width: 116px;
        font-size: 15px;

        &-secondary {
          margin-right: 20px;
          background-color: #ffffff;
          border: 1px solid #3596f4;
          color: #3596f4;
        }
      }
    }
  }
}
</style>
